import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from '../../components/ui/Tabs';
import { ReportesVentasContent } from '../../components/reports/ReportesVentasContent';
import { ProductosVendidosContent } from '../../components/reports/ProductosVendidosContent';
import { PerdidasVencimientoContent } from '../../components/reports/PerdidasVencimientoContent';
import { ProductosMenosRotanContent } from '../../components/reports/ProductosMenosRotanContent';
import { ProductosBajaContent } from '../../components/reports/ProductosBajaContent';
import { BarChart3, Package, AlertTriangle, TrendingDown, Archive } from 'lucide-react';

const TABS = [
  { id: 'reportes', label: 'Reportes de Ventas' },
  { id: 'productos-vendidos', label: 'Productos Vendidos' },
  { id: 'perdidas-vencimiento', label: 'Pérdidas por Vencimiento' },
  { id: 'menos-rotan', label: 'Productos que Menos Rotan' },
  { id: 'bajas', label: 'Bajas de Productos' },
];

export const ReportesTabsPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'reportes';

  const handleTabChange = (tabId: string) => {
    setSearchParams({ tab: tabId });
  };

  return (
    <div className="min-h-screen p-6 bg-gray-50">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 rounded-lg bg-emerald-100 text-emerald-600">
            <BarChart3 className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Reportes y Estadísticas</h1>
            <p className="text-sm text-gray-500">
              Análisis de ventas, productos vendidos y métricas de la farmacia
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <Tabs tabs={TABS} activeTab={activeTab} onChange={handleTabChange} />

      {/* Content */}
      <div className="animate-in fade-in duration-200">
        <div className={activeTab === 'reportes' ? 'block' : 'hidden'}>
          <ReportesVentasContent />
        </div>
        <div className={activeTab === 'productos-vendidos' ? 'block' : 'hidden'}>
          <ProductosVendidosContent />
        </div>
        <div className={activeTab === 'perdidas-vencimiento' ? 'block' : 'hidden'}>
          <PerdidasVencimientoContent />
        </div>
        <div className={activeTab === 'menos-rotan' ? 'block' : 'hidden'}>
          <ProductosMenosRotanContent />
        </div>
        <div className={activeTab === 'bajas' ? 'block' : 'hidden'}>
          <ProductosBajaContent />
        </div>
      </div>
    </div>
  );
};

export default ReportesTabsPage;
